module.exports = __webpack_public_path__ + "front/img/kv04.587185b2.png";